import React, { useContext } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { SiteContext } from '../../context/SiteContext';
import { ButtonContinue } from './Button/ButtonContinue';

type PopupComponentProps = {
  showPopupComponent: boolean;
  renderComponent: () => JSX.Element;
  onClosePopup: () => void;
  popupTitle: string;
};

const PopupComponent = ({
  showPopupComponent,
  renderComponent,
  onClosePopup,
  popupTitle
}: PopupComponentProps): JSX.Element => {
  const { site } = useContext(SiteContext);

  return (
    <Modal
      className={`insurance-${site.brand.brandName} modal-wide-component`}
      toggle={() => onClosePopup()}
      role='modal-popup'
      isOpen={showPopupComponent}>
      <ModalHeader toggle={() => onClosePopup()}>{popupTitle}</ModalHeader>
      <ModalBody>
        <div className='ancillary-page'>
          <div className='ancillary-main'>
            <div className=''>{renderComponent()}</div>
          </div>
        </div>
      </ModalBody>
      <ModalFooter>
        <ButtonContinue
          name='modal-btn-continue'
          text='Close'
          onClick={() => onClosePopup()}
          additionalClassNames='btn-ok'
        />
      </ModalFooter>
    </Modal>
  );
};

export default PopupComponent;
